import React, { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Bloque plegable del resumen de control: título, una frase de resumen y
// las cifras siempre visibles; el detalle se pliega.
export default function Bloque({ titulo, icono: Icono, resumen, cifras, children, abierto: inicial = true, testId }) {
  const [abierto, setAbierto] = useState(inicial);
  const id = useId();
  return (
    <section aria-labelledby={`${id}-t`} className="rounded-xl border border-border bg-card" data-testid={testId}>
      <button type="button" onClick={() => setAbierto((a) => !a)} aria-expanded={abierto} aria-controls={`${id}-c`}
        className="flex w-full items-start gap-3 rounded-xl p-4 text-left transition-colors hover:bg-muted/40
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40">
        {Icono && (
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Icono size={16} strokeWidth={2.25} aria-hidden="true" />
          </span>
        )}
        <span className="min-w-0 flex-1">
          <h2 id={`${id}-t`} className="text-base font-bold text-foreground">{titulo}</h2>
          {resumen && <span className="mt-0.5 block text-sm text-muted-foreground">{resumen}</span>}
        </span>
        <ChevronDown size={18} aria-hidden="true"
          className={`mt-1.5 shrink-0 text-muted-foreground transition-transform ${abierto ? 'rotate-180' : ''}`} />
      </button>
      {cifras && <div className="px-4 pb-3">{cifras}</div>}
      <div id={`${id}-c`} hidden={!abierto} className="border-t border-border px-4 pb-4 pt-3">
        {abierto && children}
      </div>
    </section>
  );
}

// Fila de cifras compacta: número + etiqueta, sin cajas. tono: '' | 'alerta' | 'falla'.
const TONO = { alerta: 'text-warning-foreground', falla: 'text-error', exito: 'text-success' };
export function Cifras({ items }) {
  return (
    <dl className="grid grid-cols-3 gap-x-4 gap-y-2.5 sm:grid-cols-4 lg:grid-cols-7">
      {items.filter(Boolean).map((c) => (
        <div key={c.label} className="flex min-w-0 flex-col-reverse" data-testid="cifra">
          <dt className="mt-1 text-xs leading-tight text-muted-foreground">{c.label}</dt>
          <dd className={`text-lg font-bold leading-none tabular-nums ${TONO[c.tono] || 'text-foreground'}`}>{c.valor}</dd>
        </div>
      ))}
    </dl>
  );
}
